import { CommandBar, getTheme, ICommandBarItemProps, ICommandBarStyles, IContextualMenuItem, ITextField, Stack, Text, TextField } from "@fluentui/react"
import React from "react"
import { TransactionPlaceholders } from "../../../../core/store"

type TProps = {
    title: string
    description?: string
    value?: string
    onValueChanged: (val: string | undefined) => void
    validateValue?: (value: string) => string | undefined
    getPlaceholders: (pastePlaceholder: (placeholder: TransactionPlaceholders | string) => void) => IContextualMenuItem[]
}

export const PlaceholderTextInput: React.FC<TProps> = (props) => {
    const redirectUrlTextFieldRef = React.useRef<ITextField>(null);
    const textValue = props.value ?? "";

    const pastePlaceholder = (placeholder: TransactionPlaceholders | string) => {
        const selectionStart = redirectUrlTextFieldRef.current?.selectionStart;
        const selectionEnd = redirectUrlTextFieldRef.current?.selectionEnd ?? selectionStart;
        const insertAt = selectionStart ?? textValue.length;
        const output = `${textValue.substring(0, insertAt)}${placeholder}${textValue.substring(selectionEnd ?? insertAt)}`;
        props.onValueChanged( output);
    }

    const _items: ICommandBarItemProps[] = [
        {
            key: 'placeholders',
            iconProps: { iconName: 'Variable2' },
            subMenuProps: {
                items: props.getPlaceholders( pastePlaceholder)
            }
        },
    ]

    const renderPlaceholderMenu = (): JSX.Element => {    
        return (
            <Stack horizontal verticalAlign="center" styles={{ root: { height: 32 } }}>
                <Stack.Item grow>
                    <CommandBar
                        items={_items}
                        styles={commandBarStyles}
                        overflowButtonProps={{ ariaLabel: 'More commands' }}
                        ariaLabel="Inbox actions"
                        primaryGroupAriaLabel="Main actions"
                        farItemsGroupAriaLabel="More actions"
                    />
                </Stack.Item>
            </Stack>
        )
    }

    return (
        <Stack.Item >
            <Stack horizontal style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 20, paddingBottom: 20, marginLeft: 140 }}>
                <Stack tokens={{ childrenGap: 8 }}>
                    <Stack tokens={{ childrenGap: 16 }}>
                        <Stack styles={{ root: { maxWidth: 400 } }}>
                            <Text style={{ fontWeight: 600, color: theme.palette.black }}>{props.title}</Text>
                            {props.description && (
                                <Text variant="small" style={{ color: theme.palette.neutralSecondary }}>
                                    {props.description}
                                </Text>
                            )}
                        </Stack>
                        <Stack horizontal verticalAlign="start" tokens={{ childrenGap: 4 }}>
                            <Stack.Item styles={{ root: { width: 320 } }}>
                                <TextField
                                    componentRef={redirectUrlTextFieldRef}
                                    value={textValue}
                                    onGetErrorMessage={props.validateValue}
                                    validateOnLoad={false}
                                    validateOnFocusOut
                                    onChange={(ev, value) => props.onValueChanged(value) }
                                />
                            </Stack.Item>
                            {renderPlaceholderMenu()}
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack.Item>
    )
}

const theme = getTheme();
const commandBarStyles: ICommandBarStyles = {
    root: {
        height: 32,
        margin: 0,
        padding: 0,
        selectors: {
            ".ms-CommandBar-primaryCommand": {
                height: 32,
            },
            ".ms-Button": {
                height: 32,
            },
        }
    }
};